import Selector from '@components/ui/Selector'
import { useTranslation } from 'next-i18next'
import { useRefinementList } from 'react-instantsearch'

const ColourRefinementList = () => {
  const { items, refine } = useRefinementList({
    attribute: 'named_tags.colour',
    limit: 20,
  })
  const { t } = useTranslation('common')
  if (items.length < 1) return <></>
  return (
    <>
      <div className="px-4 md:px-6">
        <div className="flex flex-col">
          {items?.map((item: any, index: any) => {
            let itemName = item?.label
            let colourHex: any
            if (item.label.includes('#')) {
              itemName = item.label.split('-')[0]
              colourHex = item.label.substring(item.label.indexOf('-') + 1)
            }
            let textColour =
              itemName == 'neutral' ||
              itemName == 'white' ||
              itemName == 'yellow'
                ? '#646464'
                : '#FFFFFF'
            return (
              <div key={index}>
                {colourHex && (
                  <div className="label facetItem flex justify-between py-3 pl-4 pr-3 capitalize">
                    {t(itemName.toLowerCase())}
                    <div
                      onClick={(event) => {
                        event.preventDefault()
                        refine(item.value)
                      }}
                    >
                      <Selector selected={item.isRefined} />
                    </div>
                  </div>
                )}
                <style jsx>
                  {`
                    .facetItem {
                      background-color: ${colourHex};
                      color: ${textColour};
                    }
                  `}
                </style>
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}

export default ColourRefinementList
